import { create } from "zustand";

export const useGlobalLoader = create((set) => ({
    globalLoader: false,

    setGlobalLoader: (e) => {
        set({
            globalLoader: e
        })
    }
}))